export const initialState = {
	plans: [],
	promoDetails: {}
};
